import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/css/all.scss'
import utils from './utils/index'
import locale from 'element-plus/lib/locale/lang/zh-cn'
import VueImageLightbox from 'vue-image-lightbox'

const app = createApp(App)

// 注册全局组件-icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 引用组件
import commonForm from '@/components/commonForm'
import commonPagination from '@/components/commonPagination'
app.component('commonForm', commonForm)
app.component('commonPagination', commonPagination)
app.component('VueImageLightbox', VueImageLightbox)

// 注册全局组件-自定义
app.config.globalProperties.$utils = utils
app.use(store).use(router).use(ElementPlus, { locale }).mount('#app')
